import { render, staticRenderFns } from "./SuggestLog.vue?vue&type=template&id=aadd27d8&"
import script from "./SuggestLog.vue?vue&type=script&lang=js&"
export * from "./SuggestLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports